import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    flowType: 'default',
    currentStepIndex: 0,
    currentSubstepIndex: 0,
    navigationDirection: null,
};

const bniTravelInsuranceFlowSlice = createSlice({
    name: 'bniTravelInsuranceFlow',
    initialState,
    reducers: {
        setBniTravelFlowType: (state, action) => {
            const { type, currentStepIndex, currentSubstepIndex } = action.payload;
            state.flowType = type;
            state.currentStepIndex = currentStepIndex || 0;
            state.currentSubstepIndex = currentSubstepIndex || 0;
        },
        setBniTravelCurrentStepIndex: (state, action) => {
            const newStepIndex = action.payload;
            const direction = newStepIndex > state.currentStepIndex ? 'forward' : 
                            newStepIndex < state.currentStepIndex ? 'backward' : null;
            state.currentStepIndex = newStepIndex;
            state.navigationDirection = direction;
        },
        setBniTravelCurrentSubstepIndex: (state, action) => {
            const newSubstepIndex = action.payload;
            const direction = newSubstepIndex > state.currentSubstepIndex ? 'forward' : 
                            newSubstepIndex < state.currentSubstepIndex ? 'backward' : null;
            state.currentSubstepIndex = newSubstepIndex;
            state.navigationDirection = direction;
        },
        setBniNavigationDirection: (state, action) => {
            state.navigationDirection = action.payload;
        },
        resetBniTravelFlow: (state) => {
            return initialState;
        },
    },
});

export const {
    setBniTravelFlowType,
    setBniTravelCurrentStepIndex,
    setBniTravelCurrentSubstepIndex,
    setBniNavigationDirection,
    resetBniTravelFlow,
} = bniTravelInsuranceFlowSlice.actions;

export const selectBniTravelFlowType = (state) => state.bniTravelInsuranceFlow.flowType;
export const selectBniTravelCurrentStepIndex = (state) => state.bniTravelInsuranceFlow.currentStepIndex;
export const selectBniTravelCurrentSubstepIndex = (state) => state.bniTravelInsuranceFlow.currentSubstepIndex;
export const selectBniNavigationDirection = (state) => state.bniTravelInsuranceFlow.navigationDirection;

export default bniTravelInsuranceFlowSlice.reducer;
